export default __webpack_public_path__ + "static/media/00.276e767f.jpg";